import { DeleteMomentContext, StarQuoteContext } from '@trinity/chat-components/containers/Transcript/context.js';
import { useDeleteTranscriptMomentMutation, useStarTranscriptQuoteMutation } from '@/utils/api';

export const TranscriptGoodQuoteCompatContainer = (props: ChildrenProps) => {

  const { mutateAsync: starQuote } = useStarTranscriptQuoteMutation();
  const { mutateAsync: deleteMoment } = useDeleteTranscriptMomentMutation();

  return (
    <StarQuoteContext.Provider value={starQuote}>
      <DeleteMomentContext.Provider value={deleteMoment}>
        {props.children}
      </DeleteMomentContext.Provider>
    </StarQuoteContext.Provider>
  );
};